$(document).ready(() => {
    const updateTitleHeight = () => {
        // Iterate over each ".find-out-more-section .find-out-more-row .col-left"
        $(".find-out-more-section .find-out-more-row .col-left").each(function() {
            // Calculate the height of the current ".col-left"
            let titleHeight = $(this).outerHeight(true);

            // Find the corresponding ".col-right" within the same row
            let $colRight = $(this).closest(".find-out-more-row").find(".col-right");

            // Set the CSS variable "--title-height" on the corresponding ".col-right"
            $colRight.css("--title-height", `${titleHeight}px`);
        });
    };

    // Initial call
    updateTitleHeight();

    // Update on window resize
    $(window).on("resize", updateTitleHeight);
});